import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import { useForm } from 'react-hook-form';

import Form from 'react-bootstrap/Form';
import Query from '@queries/customer-stories/Filters';
import Row from '@common/Row';
import Button from '@common/Button';

const CustomerStoriesFilter = ({ bgColour = 'teal' }) => {
  const data = Query();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { register, handleSubmit, setValue } = useForm();
  const [locationFilter, setLocationFilter] = useState(['']);
  const [sizeFilter, setSizeFilter] = useState(['']);
  const [featureFilter, setFeatureFilter] = useState(['']);
  const onSubmit = (data) => {
    const params = new URLSearchParams();
    // Convert obj into array
    const query = Object.entries(data);
    // Add in url navigation to filtered page
    query.forEach(x => {
      if (x[1] != ''){
        params.set(x[0], x[1]);
      }
    });
    navigate(`/resources/customer-stories/search?${params.toString()}`);
  };
  const createFilterList = (list, key) => {
    const newList = []
    for (let i = 0; i < list?.length; i++) {
      const node = list[i]?.node.customer;
      if (Array.isArray(node[key])) {
        for (let j = 0; j < node[key]?.length; j++) {
          if (newList.findIndex(x => x === node[key][j]) === -1 && node[key][j] != null) {
            if (node[key][j] !== 'Physical Curriculum' && node[key][j] !== 'Digital Curriculum' && node[key][j] !== 'Activity Planning') {
              newList.push(node[key][j]);
            }
            if ((node[key][j] === 'Physical Curriculum' || node[key][j] === 'Digital Curriculum' || node[key][j] === 'Activity Planning') && newList.findIndex(x => x === 'Curriculum') === -1) {
              newList.push('Curriculum');
            }
          }
        }
      }
      else if (newList.findIndex(x => x === node[key]) === -1 && node[key] != null) {
        newList.push(node[key]);
      }
    }
    return newList.sort(function(a, b) {
      return parseInt(a?.split('-')[0]) - parseInt(b?.split('-')[0]);
    });
  }
  useEffect(() => {
    // Full list data
    const list = data.allContentfulCustomerStory.edges;

    // Create filter list
    const newLocationList = createFilterList(list, 'location');
    const newSizeList = createFilterList(list, 'centerSize');
    const newFeatureList = createFilterList(list, 'features');

    // Set filter list
    setLocationFilter(newLocationList);
    setSizeFilter(newSizeList);
    setFeatureFilter(newFeatureList);
  }, [data]);
  useEffect(() => {
    // Check for existing values in url
    const location = params.get('location');

    // Set form values
    if (location) {
      setValue('location', location)
    }
  }, [locationFilter]);
  useEffect(() => {
    // Check for existing values in url
    const centerSize = params.get('centerSize');

    // Set form values
    if (centerSize) {
      setValue('centerSize', centerSize)
    }
  }, [sizeFilter]);
  useEffect(() => {
    // Check for existing values in url
    const features = params.get('features');

    // Set form values
    if (features) {
      setValue('features', features)
    }
  }, [featureFilter]);
  return (
    <Row className={`rounded pt-3 pb-4 mb-3 mx-3 mx-lg-0 bg-${bgColour}`}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)} className='d-flex flex-column flex-lg-row'>
        <Form.Group controlId='location' className='col-lg-3 px-2 mb-3 mb-lg-0'>
          <Form.Label className='fw-normal fs-14 ff-sans-serif ms-2'>{'Filter by location'}</Form.Label>
          <Form.Select
            name='location'
            className='bg-white border-0'
            {...register('location')}
          >
            <option value=''>{'All locations'}</option>
            {locationFilter.map((location, index) => (
              <option key={index} value={location}>{location}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group controlId='centerSize' className='col-lg-3 px-2 mb-3 mb-lg-0'>
          <Form.Label className='fw-normal fs-14 ff-sans-serif ms-2'>{'Filter by program size'}</Form.Label>
          <Form.Select
            name='centerSize'
            className='bg-white border-0'
            {...register('centerSize')}
          >
            <option value=''>{'All sizes'}</option>
            {sizeFilter.map((size, index) => (
              <option key={index} value={size}>{size}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group controlId='features' className='col-lg-3 px-2 mb-3 mb-lg-0'>
          <Form.Label className='fw-normal fs-14 ff-sans-serif ms-2'>{'Filter by solutions'}</Form.Label>
          <Form.Select
            name='features'
            className='bg-white border-0'
            {...register('features')}
          >
            <option value=''>{'All solutions'}</option>
            {featureFilter.map((feature, index) => (
              <option key={index} value={feature}>{feature}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <div className='d-flex col-lg-3 align-items-end px-2'>
          <Button
            variant='black'
            copy='Search stories'
            addClass='w-100 fs-18'
          />
        </div>
      </Form>
    </Row>
  )
}

export default CustomerStoriesFilter
